import React, { useContext } from 'react';
import { Stack, Text } from 'library/ui';

import { PreferredWorkerModalContext } from './PreferredWorkerModalContext';
import { ShiftProviderUser } from 'models';

export default function Header() {
    const { provider }: { provider: ShiftProviderUser } = useContext(PreferredWorkerModalContext);

    return (
        <Stack gap="sm">
            <Text size="sm" tone="secondary">
                You can add preferred workers business wide or at specific locations using the options below.
            </Text>
            <Text>
                Add{' '}
                <Text weight="bold">
                    {provider.first_name} {provider.last_name}
                </Text>{' '}
                to:
            </Text>
        </Stack>
    );
}
